import { _ as __rest, a as __assign, b as __spreadArray } from './tslib.es6-18cb2814.js';
import { c as classNames } from './index-8887fc24.js';
import * as React from 'react';
import React__default from 'react';
import './countries-34fea817.js';
import { L as LeftArrowIcon } from './LeftArrowIcon-56518555.js';
import { B as Button } from './index-b7114926.js';
import { FilterSelect } from './es/components/FilterSelect.js';

function RightArrowIcon(_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React__default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 12" }, props),
        React__default.createElement("g", { transform: "rotate(180 8 6)" },
            React__default.createElement("path", { fill: fillColor, fillRule: "nonzero", d: "M15.667 5.167V6.5c0 .4-.267.667-.667.667H4.867l2.4 2.4c.133.133.133.333 0 .466l-1.4 1.4c-.134.134-.334.134-.467 0l-5.2-5.2c-.267-.266-.267-.666 0-.933L5.4.1c.133-.133.333-.133.467 0l1.4 1.4c.133.133.133.333 0 .467l-2.4 2.4H15c.4.133.667.4.667.8z" }))));
}

var styles = {"outerContainer":"PaginationRange_outerContainer_bf708617","withPageSizePicker":"PaginationRange_withPageSizePicker_bf708617","spacer":"PaginationRange_spacer_bf708617","list":"PaginationRange_list_bf708617","listItem":"PaginationRange_listItem_bf708617","button":"PaginationRange_button_bf708617","prevNext":"PaginationRange_prevNext_bf708617","selected":"PaginationRange_selected_bf708617 PaginationRange_button_bf708617","icon":"PaginationRange_icon_bf708617"};

function paginate(current, initial, total, max) {
    max = Math.min(total, max);
    var offset = Math.floor(max / 2);
    var start = Math.max(initial, current - offset);
    var end = Math.max(max, Math.min(total, current + offset));
    start -= max - (end - start) - 1;
    var res = [];
    for (var i = start; i <= end; ++i) {
        res.push(i);
    }
    return res;
}
function boundaries(list, initial, total) {
    var boundaryList = __spreadArray(__spreadArray([
        initial
    ], list.slice(1, list.length - 1), true), (total > 1 ? [total] : []), true);
    if (total > boundaryList.length) {
        return boundaryList.map(function (value, index, arr) {
            if (index === 1) {
                var prev = arr[index - 1];
                var dist = value - prev;
                return dist === 1 ? value : "...";
            }
            if (index === arr.length - 2) {
                var next = arr[index + 1];
                var dist = next - value;
                return dist === 1 ? value : "...";
            }
            return value;
        });
    }
    return boundaryList;
}
var usePaginationRange = function (props) {
    var _a, _b, _c, _d;
    var _e = React.useState(props.page || 1), page = _e[0], setPage = _e[1];
    var _f = React.useState(props.pageSize || props.defaultPageSize || 10), pageSize = _f[0], setPageSize = _f[1];
    var minPages = 5;
    var current = (_a = props.page) !== null && _a !== void 0 ? _a : page;
    var siblings = (_b = props.siblings) !== null && _b !== void 0 ? _b : 1;
    var handleClick = function (event, index) {
        if (event.preventDefault) {
            event.preventDefault();
        }
        if (!props.page) {
            // uncontrolled
            setPage(index);
        }
        if (props.onUpdatePageIndex) {
            props.onUpdatePageIndex(index);
        }
    };
    var pages = paginate(current, 1, props.total, minPages + siblings * 2);
    var bounded = boundaries(pages, 1, props.total);
    var items = bounded.map(function (value) {
        if (value === "...") {
            return {
                name: "ellipsis",
                disabled: true,
            };
        }
        return {
            name: "page",
            index: +value,
            selected: current === value,
            onClick: function (event) { return handleClick(event, +value); },
        };
    });
    if (props.isPrevNext) {
        items.unshift({
            name: "previous",
            index: Math.max(current - 1, 1),
            disabled: current === 1,
            onClick: function (event) { return handleClick(event, current - 1); },
        });
        items.push({
            name: "next",
            index: current + 1,
            disabled: current === props.total,
            onClick: function (event) { return handleClick(event, current + 1); },
        });
    }
    var pageSizeOptions = ((_c = props.pageSizes) !== null && _c !== void 0 ? _c : [10, 25, 50, 100]).map(function (value) { return ({ label: value, value: value.toString() }); });
    var pageInfo = {
        items: pageSizeOptions,
        selectedItem: (_d = pageSizeOptions.find(function (p) { return p.label === pageSize; })) !== null && _d !== void 0 ? _d : pageSizeOptions[0],
        handleSelectedItemChange: function (item) {
            var value = (item === null || item === void 0 ? void 0 : item.label) || pageSizeOptions[0].label;
            // prevents pageSize being set on pageIndex change in controlled component
            if (pageSize !== value) {
                props.onPageSizeChange && props.onPageSizeChange(value);
            }
            setPageSize(value);
        },
    };
    return {
        items: items,
        pageInfo: pageInfo,
    };
};

function getButtonLabel(name, index) {
    switch (name) {
        case "ellipsis":
            return "...";
        case "previous":
            return (React.createElement("span", { className: styles.icon },
                React.createElement(LeftArrowIcon, null)));
        case "next":
            return (React.createElement("span", { className: styles.icon },
                React.createElement(RightArrowIcon, null)));
        default:
            return index;
    }
}
function getAriaLabel(name, index) {
    switch (name) {
        case "previous":
            return "Go to previous page";
        case "next":
            return "Go to next page";
        case "ellipsis":
            return "Ellipsis";
        default:
            return "Go to page ".concat(index);
    }
}
var PaginationButton = function (props) {
    var _a;
    var buttonRef = React.useRef(null);
    var selected = props.selected, index = props.index, onClick = props.onClick, itemProps = __rest(props, ["selected", "index", "onClick"]);
    React.useEffect(function () {
        if (buttonRef.current !== null) {
            var isActive = document.activeElement === buttonRef.current;
            if (!selected && isActive && itemProps.name === "page") {
                buttonRef.current.blur();
            }
        }
    }, [selected, itemProps.name, index]);
    return (React.createElement(Button, __assign({ ref: buttonRef, type: "button", "aria-label": getAriaLabel(itemProps.name, index), variant: selected ? "secondary" : "tertiary", color: "interface", "data-testid": "pagination-range-button-".concat(itemProps.name), className: classNames(styles.button, (_a = {},
            _a[styles.prevNext] = itemProps.name === "previous" || itemProps.name === "next",
            _a)), onClick: onClick }, itemProps), getButtonLabel(itemProps.name, index)));
};
var PaginationRange = React.forwardRef(function PaginationRange(props, ref) {
    var _a;
    var className = props.className, showPageSizePicker = props.showPageSizePicker, footerElement = props.footerElement, _b = props.popoverPlacement, popoverPlacement = _b === void 0 ? "bottom" : _b, otherProps = __rest(props, ["className", "showPageSizePicker", "footerElement", "popoverPlacement"]);
    var _c = usePaginationRange(otherProps), items = _c.items, pageInfo = _c.pageInfo;
    return (React.createElement("div", { className: classNames(styles.outerContainer, (_a = {},
            _a[styles.withPageSizePicker] = showPageSizePicker,
            _a)), "data-testid": "pagination-range-footer-element" },
        footerElement,
        React.createElement("nav", { ref: ref, className: classNames(styles.container, className), "aria-label": "pagination" },
            React.createElement("ul", { className: styles.list }, items.map(function (item, index) { return (React.createElement("li", { className: styles.listItem, key: index },
                React.createElement(PaginationButton, __assign({}, item)))); }))),
        showPageSizePicker && (React.createElement(FilterSelect, __assign({ type: "single", label: "Rows per page", "data-testid": "pagination-page-size", popoverPlacement: popoverPlacement }, pageInfo)))));
});

export { PaginationRange as P, RightArrowIcon as R };
